<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" width="1000px" :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
    <el-table v-loading="loading" :data="List" border :highlight-current-row="true">
      <el-table-column prop="file_Name" :label="$t('SeaFreight.FileName')" min-width="300" />
      <!-- <el-table-column prop="file_Type" :label="文件类型" width="150" />
      <el-table-column prop="creater_Name" :label="创建人" width="150" />
      <el-table-column prop="creater_Date" :label="创建时间" width="150" :formatter="formatterTime" /> -->
      <el-table-column prop="file_Url" :label="$t('SeaFreight.Operate')" width="120">
        <template slot-scope="scope">
          <div>
            <!-- <a class="el-link el-link--primary" style="display: block;width: 70px" @click="dfLoad(scope.row)">{{ $t('global.see') }}</a> -->
            <!-- <a :href="scope.row.file_Url" target="_blank" style="color:blue" :download="scope.row.file_Name"><i class="fa fa-download" />  {{ $t('global.see') }}</a> -->
            <el-button type="text" size="small" style="color:red" @click="dfLoad(scope.row)">
              {{ $t('SeaFreight.Download') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button type="crud" @click="closeDialog">{{ $t('SeaFreight.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import dialog from '@/components/fms/mixins/dialog'
import { convertYMD } from '@/utils/index.js'
import { getAllFileListByBookingNo } from '@/api/ocean/order/oi/index'
import { getFileListByBookingNo, getFileBlob } from '@/api/ocean/order/oe/index'
import { getMMFileListByBookingNo } from '@/api/ocean/order/mm/index'
import { ISStr } from '@/utils/isClass'
import i18n from '@/i18n/i18n'
export default {
  components: {},
  mixins: [dialog],
  props: {
    curRow: {
      type: Object,
      default: () => {}
    },
    jobType: {
      type: String,
      default: 'OE'
    }
  },
  data() {
    return {
      loading: false,
      List: []
    }
  },
  computed: {},
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      const data = {
        BookingNo: this.curRow.Booking_No
      }
      this.loading = true
      var res = []
      if (this.jobType === 'OE') {
        res = await getFileListByBookingNo(data)
      } else if (this.jobType === 'OI') {
        res = await getAllFileListByBookingNo(data)
      } else if (this.jobType === 'MM') {
        res = await getMMFileListByBookingNo(data)
      }
      this.loading = false
      if (res && res.isSuccess) {
        this.List = res.data
      }
    },
    formatterTime(row, column) {
      return convertYMD(row[column.property])
    },
    dfLoad(row) {
      getFileBlob({ Url: row.file_Url }).then((res) => {
        if (!ISStr(res.data)) {
          var fileContent = res.data // 从后端获取的 byte[] 转换成的字符串
          // 将字符串转换为 byte[]
          var byteCharacters = atob(fileContent)
          var byteArray = new Uint8Array(byteCharacters.length)
          for (var i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i)
          }
          // 创建 Blob 对象
          var blob = new Blob([byteArray], { type: 'application/octet-stream' })
          this.DownloadItem(blob, row.file_Name)
        } else {
          // 获取文件地址信息失败，打开新页面显示附件
          const link = document.createElement('a')
          link.href = row.file_Url
          link.download = row.file_Name
          link.target = '_blank'
          link.click()
        }
      })
      // this.getBlob(row.file_Url).then((blob) => {
      //   this.DownloadItem(blob, row.fileName)
      // })
    },
    getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          if (xhr.status === 200) {
            const reader = new FileReader()
            reader.onload = (event) => {
              try {
                const content = this.decodeUnicode(
                  JSON.parse(event.target.result)
                )
                if (content.isSuccess === false) {
                  this.messagebox.alert(content.msg)
                } else {
                  resolve(xhr.response)
                }
              } catch (error) {
                resolve(xhr.response)
              }
            }
            reader.readAsText(xhr.response)
          }
        }
        xhr.onerror = () => {
          console.log('请求异常：' + xhr.statusText)
        }
        xhr.send()
      })
    },
    DownloadItem(blob, fileName) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      link.click()
    },
    decodeUnicode(obj) {
      for (var key in obj) {
        if (typeof obj[key] === 'string') {
          obj[key] = unescape(obj[key].replace(/\\u/g, '%u'))
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.decodeUnicode(obj[key])
        }
      }
      return obj
    }
  }
}
</script>
<style scoped>
</style>
